<template>
    <div>
        <h2 class="text-xl font-bold mt-6 mb-4">{{ title}}</h2>
        <div v-for="(row, index) in rows" :key="index" class="flex flex-wrap w-full">
            <div class="flex flex-wrap w-full">
                <div class="lg:w-1/2">
                    <text-input v-model="row.document_name" :error="row.errors?.document_name"
                                class="pb-8 pr-6 w-full lg:w-full" label="Document Name"
                    />
                </div>
                <div class="lg:w-1/2">
                    <!-- Student Photo Upload Section -->
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <h3 class="font-bold mb-4">Document {{ index + 1 }}</h3>
                        <file-pond
                            type="file"
                            :name="`photo_${index}`"
                            :files="getPreloadedFile('document_'+index)"
                            @change="handlePhotoChange($event, index)"
                            @removefile="removeFile('document_'+index)"
                            class="form-input w-full photo-preview"
                            accept="image/*"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full flex justify-center mb-6">
            <button @click.prevent="removeDocument(index)" class="btn btn-danger mr-2" v-if="rows.length > 1">
                Remove Document
            </button>
            <button @click.prevent="addDocument" class="btn btn-primary">Add Document</button>
        </div>

    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/vue3'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import TextInput from '@/Shared/TextInput'

// Register the FilePond component globally
const FilePond = vueFilePond()

export default {
    name: 'DocumentList',
    props: {
        modelValue: {
            type: Array,
            required: true,
            default: () => [], // Empty array by default
        },
        title: {
            type: String,
            default: 'Document List',
        },
        getPreloadedFile: {
            type: Function,
            required: true, // Expect the function to be passed from the parent
        },
    },
    components: { Icon, Link, FilePond, TextInput },
    emits: ['update:modelValue'], // Emit when modelValue changes
    data() {
        return {
            photos: {},
        }
    },
    computed: {
        rows: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value) // Emit the updated value back to the parent
            },
        },
    },
    methods: {
        addDocument() {
            this.rows.push({
                id: Date.now() + Math.random(),
                document_name: '',
            })
        },
        removeDocument(index) {
            if (this.rows.length > 1) {
                this.rows.splice(index, 1)
            }
        },
        handlePhotoChange(event, index) {
            this.$emit('documentChange', event, "document_"+index)
        },
        removeFile(name){
            this.$emit('documentRemoveImage', name)
        }

    },
}
</script>
